// ** React Imports

// ** Third Party Components
import * as yup from "yup"
import { useFormik } from "formik"

// ** Reactstrap Imports
import { FormFeedback, Input, Label, Button, Modal } from "reactstrap"
import Select from "react-select"
import CustomSpinner from "../../../../components/spinners/CustomSpinner"
import { useEffect, useState } from "react"

// ** Styles

const AutoSeguroForm = (props) => {
  // ** State
  const catTipoVehiculo = [
    {
      label: "Auto",
      value: "Auto"
    },
    {
      label: "Pick Up",
      value: "Pick Up"
    }
  ]
  const [catTipo, setCatTipo] = useState([])
  const catPickup = [
    { label: "Particular", value: "Particular" },
    { label: "multiplataforma", value: "multiplataforma" }
  ]
  const catAuto = [{ label: "Convertible", value: "Convertible" }]
  const catMarcas = [
    { label: "Honda", value: "Honda" },
    { label: "Kia", value: "Kia" },
    { label: "Ford", value: "Ford" },
    { label: "Toyota", value: "Toyota" }
  ]
  const catModelo = [
    { label: "2021", value: "2021" },
    { label: "2020", value: "2020" },
    { label: "2019", value: "2019" }
  ]

  const validationSchema = () => {
    return yup.object({
      /*
      edadRetirarte: yup.string(),
      monedaRetiro: yup.string(),
      rentaRetiro: yup.string()
      */
    })
  }

  function initialValues() {
    if (props.accion === 1) {
      return {
        nombre: "",
        telefono: "",
        correo: "",
        cp: "",
        tipoVehiculo: "",
        tipoConductor: "",
        marca: "",
        modelo: ""
      }
    } else {
      return props.data
    }
  }

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    onSubmit: (data, { resetForm }) => {
      data = {
        ...data,
        accion: props.accion,
        tipo: "personal",
        nombre: "Auto Seguro",
        slug: "auto-seguro"
      }
      props.administrar(data, props.handleSuccess)
      resetForm()
    }
  })

  useEffect(() => {
    if (formik.values.tipoVehiculo == "Auto") {
      setCatTipo(catAuto)
    } else if (formik.values.tipoVehiculo == "Pick Up") {
      setCatTipo(catPickup)
    }
  }, [formik.values.tipoVehiculo])

  return (
    <div>
      <Modal isOpen={props.loading}>
        <CustomSpinner />
      </Modal>
      <h1 className="mb-2 col-12 text-center">Auto seguro</h1>
      <div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            Nombre completo
          </Label>
          <Input
            invalid={formik.errors.nombre && true}
            value={formik.values.nombre}
            onChange={(e) => {
              formik.setFieldValue("nombre", e.target.value)
            }}
          />
          {formik.errors.nombre && (
            <FormFeedback>{formik.errors.nombre}</FormFeedback>
          )}
        </div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            Télefono:
          </Label>
          <Input
            type="number"
            invalid={formik.errors.telefono && true}
            value={formik.values.telefono}
            onChange={(e) => {
              formik.setFieldValue("telefono", e.target.value)
            }}
          />
          {formik.errors.telefono && (
            <FormFeedback>{formik.errors.telefono}</FormFeedback>
          )}
        </div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            Correo Electrónico:
          </Label>
          <Input
            invalid={formik.errors.correo && true}
            value={formik.values.correo}
            onChange={(e) => {
              formik.setFieldValue("correo", e.target.value)
            }}
          />
          {formik.errors.correo && (
            <FormFeedback>{formik.errors.correo}</FormFeedback>
          )}
        </div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            C.P.:
          </Label>
          <Input
            type="number"
            invalid={formik.errors.cp && true}
            value={formik.values.cp}
            onChange={(e) => {
              formik.setFieldValue("cp", e.target.value)
            }}
          />
          {formik.errors.cp && <FormFeedback>{formik.errors.cp}</FormFeedback>}
        </div>
        <div className="mb-1">
          <Label className="form-label" for="tipo">
            Tipo de vehiculo
          </Label>
          <Select
            value={
              formik.values.tipoVehiculo != ""
                ? {
                    label: formik.values.tipoVehiculo,
                    value: formik.values.tipoVehiculo
                  }
                : ""
            }
            className="react-select"
            classNamePrefix="select"
            placeholder="Seleccionar"
            defaultValue={catTipoVehiculo[0]}
            options={catTipoVehiculo}
            isClearable={false}
            onChange={(e) => {
              formik.setFieldValue("tipoVehiculo", e.value)
            }}
          />
          {formik.errors.tipoVehiculo && (
            <FormFeedback>{formik.errors.tipoVehiculo}</FormFeedback>
          )}
        </div>
        {catTipo.length > 0 && (
          <div className="mb-1">
            <Label className="form-label" for="tipo">
              Tipo
            </Label>
            <Select
              value={
                formik.values.tipoConductor != ""
                  ? {
                      label: formik.values.tipoConductor,
                      value: formik.values.tipoConductor
                    }
                  : ""
              }
              placeholder="Seleccionar"
              className="react-select"
              classNamePrefix="select"
              options={catTipo}
              isClearable={false}
              onChange={(e) => {
                formik.setFieldValue("tipoConductor", e.value)
              }}
            />
            {formik.errors.monedaRetiro && (
              <FormFeedback>{formik.errors.monedaRetiro}</FormFeedback>
            )}
          </div>
        )}
        {formik.values.tipoConductor != "" && (
          <div className="mb-1">
            <Label className="form-label" for="tipo">
              Marca
            </Label>
            <Select
              value={
                formik.values.marca != ""
                  ? {
                      label: formik.values.marca,
                      value: formik.values.marca
                    }
                  : ""
              }
              placeholder="Seleccionar"
              className="react-select"
              classNamePrefix="select"
              defaultValue={catMarcas[0]}
              options={catMarcas}
              isClearable={false}
              onChange={(e) => {
                formik.setFieldValue("marca", e.value)
              }}
            />
            {formik.errors.marca && (
              <FormFeedback>{formik.errors.marca}</FormFeedback>
            )}
          </div>
        )}

        {formik.values.marca != "" && (
          <div className="mb-1">
            <Label className="form-label" for="tipo">
              Modelo
            </Label>
            <Select
              value={
                formik.values.modelo != ""
                  ? {
                      label: formik.values.modelo,
                      value: formik.values.modelo
                    }
                  : ""
              }
              placeholder="Seleccionar"
              className="react-select"
              classNamePrefix="select"
              menuPlacement="top"
              defaultValue={catModelo[0]}
              options={catModelo}
              isClearable={false}
              onChange={(e) => {
                formik.setFieldValue("modelo", e.value)
              }}
            />
            {formik.errors.modelo && (
              <FormFeedback>{formik.errors.modelo}</FormFeedback>
            )}
          </div>
        )}
      </div>
      <div className="d-flex justify-content-end">
        <Button className="me-1" color="primary" onClick={formik.handleSubmit}>
          {props.accion === 1 ? "Guardar" : "Guardar cambios"}
        </Button>
      </div>
    </div>
  )
}

export default AutoSeguroForm
